import React from 'react'
import styled from '@emotion/styled'
import {ContentHotel} from '@findhotel/sapi'
import {ReviewSummary} from 'components/Reviews/ReviewSummary'

import {cssTheme} from '@vio/atlas/src/themes'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'
import {Entity} from '@vio/core/src/analytics/types/Events'
import {ReviewRating} from '@vio/shared/src/search/ReviewRating'

import {ReviewsTrackClick, SelectedElementType} from './ReviewsTrackClick'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s500};
  grid-area: rating;
  padding: 0 ${cssTheme.layout.spacing.s500};
  ${linariaMq.desktopMd} {
    padding: 0;
    gap: ${cssTheme.layout.spacing.s600};
  }
`

interface Props {
  hasReviews: boolean
  hasSummary: boolean
  isAiPoweredInsightsEnabled: boolean
  hotel: ContentHotel
}
export const ReviewSectionRating: React.FC<Props> = ({
  hasReviews,
  hasSummary,
  isAiPoweredInsightsEnabled,
  hotel
}) => {
  return (
    <Wrapper>
      {hasReviews && (
        <ReviewsTrackClick
          dataId="reviews-subsection"
          element={SelectedElementType.Rating}
          entity={Entity.HotelDetailsReviewsSection}
        >
          <ReviewRating
            rating={hotel.guestRating.overall}
            totalRatingCount={hotel.reviewCount}
            hotelId={hotel.objectID}
            variant="large"
          />
        </ReviewsTrackClick>
      )}
      {hasSummary && !isAiPoweredInsightsEnabled && (
        <div data-id="review-summary">
          <ReviewSummary guestRating={hotel?.guestRating} />
        </div>
      )}
    </Wrapper>
  )
}
